import { OrganizationType } from '../../store/state'

const getTotalInstitutions = (organizations: OrganizationType) => {
  return organizations.items.reduce((sum, org) => sum + org.nbInstitutions, 0)
}

export default getTotalInstitutions
